import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "app/services/http-services/request-interceptor";
import { useTranslation } from "react-i18next";
import queryKeys from "shared/services/queryKeys";
import { FormLayoutData } from "../services/formLayoutBuilder";

export function useFormLayout(tableId?: string, viewId?: string | null, enabled = true) {
    const { i18n } = useTranslation();
    const { data, isLoading } = useQuery({
        queryKey: queryKeys.records.config("sys_form_sections", { sys_table_id: tableId, view_id: viewId, language: i18n.language }),
        enabled: enabled && Boolean(tableId && viewId),
        staleTime: 60_000,
        retry: false,
        queryFn: async (): Promise<FormLayoutData | null> => {
            const response = await axiosInterceptor.get<{ data: FormLayoutData }>(
                `/api/form_layout/views/${viewId}/layout`, { params: { table_id: tableId, language: i18n.language } },
            );
            const layout = response.data.data;
            return layout?.sections?.length ? layout : null;
        },
    });
    return { layout: viewId ? data ?? null : null, isLoading: Boolean(viewId) && isLoading };
}
